import type { IData } from './TechStack.types';

export const data: IData = {
  mainText: 'Our tech stack:',
  technologies: {
    firstColumn: [
      'Aave',
      'Account Abstraction',
      'Alchemy',
      'Arbitrum',
      'Balancer',
      'Balancer Pools',
      'Bitcoin',
      'Chainlink',
      'Circle',
      'Circom',
      'Compound',
      'ENS',
      'Ethereum',
    ],
    secondColumn: [
      'Ethers',
      'EVM',
      'Gnosis Multisig',
      'Gnosis Protocol',
      'Hardhat',
      'IPFS',
      'libp2p',
      'Matic/Polygon',
      'MetaMask',
      'Oasis Network',
      'Optimism',
      'OrbitDB',
      'Ox SDK',
    ],
    thirdColumn: [
      'Polygon',
      'Solidity',
      'Subgraph',
      'Synpress',
      'Rust',
      'Typechain',
      'UMA',
      'Uniswap',
      'USDC',
      'Vyper',
      'Yearn',
      'ZKSync',
    ],
  },
};
